import { FileCollectionItemT, ObjectContainerClientT } from 'bovaljaren-models';
import { stat } from 'fs';
import React, { ReactElement, useContext } from 'react';
import { ObosDownload } from '../../../../../icons/obos/obosIcons';
import { AppContext } from '../../../../../state/app.state';

type ObjectViewDocumentProps={
    showDocuments: boolean;
    selectedObject?: ObjectContainerClientT
};

const ObjectViewDocument: React.FC<ObjectViewDocumentProps> = ({ showDocuments, selectedObject }): ReactElement => {
    const { state } = useContext(AppContext);

    return (
        showDocuments ? <div className={'bv-doc-center'}>
            <div className={'bv-doc-wrapper'}>
                <h2 className="bv-doc-header">Ladda ner dokument</h2>
                {selectedObject?.documentCollectionId && state?.fileCollections?.find((fC: { id: number; }) => fC.id === selectedObject.documentCollectionId)?.files.map(f => {
                    return <a
                        key={f.id}
                        className='bv-doc-link'
                        href={f.url?.original}
                        download={f.filename}
                        target="__blank">
                        <p className='bv-doc-text'>{f.listName}</p>
                        <ObosDownload className={'bv-ov-doc-icon'}/>
                    </a>;
                })}
            </div>
        </div> : <></>
    );
};


export default ObjectViewDocument;